import { SearchTerm } from "./SearchTerm";

const PresetOutputModeSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "trnName",
        translationKey: "name"
    },
];

export default PresetOutputModeSearch;
